<template>
  <div>
    <slot name="customChild"></slot>
  </div>
</template>

<script>
export default {
  data: () => ({
    observer: null,
  }),
  mounted() {
    const options = this.options || {};
    this.observer = new IntersectionObserver(([entry]) => {
      if (entry && entry.isIntersecting) this.$emit('intersect');
    });
    this.observer.observe(this.$el);
  },
  unmounted() {
    this.observer.disconnect();
  },
};
</script>
